export const VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

const SAFE_RELOAD_PATHS = new Set([
  '/',
  '/dashboard',
  '/auth/signin',
  '/auth/account-activation',
  '/auth/message-forgot-password',
  '/privacy-policy',
  '/website-agreement',
  '/term-and-condition-public',
  '/not-found',
]);

export const isSafeReloadPath = (pathname) => SAFE_RELOAD_PATHS.has(pathname);

export const isValidReleasePayload = (payload) => (
  payload !== null &&
  typeof payload === 'object' &&
  typeof payload.version === 'string' &&
  payload.version.trim().length > 0
);

export const buildVersionUrl = (publicUrl = '', timestamp = Date.now()) => {
  const normalizedPublicUrl = publicUrl.endsWith('/')
    ? publicUrl.slice(0, -1)
    : publicUrl;

  return `${normalizedPublicUrl}/version.json?t=${timestamp}`;
};

export const isChunkLoadError = (error) => {
  const name = error && error.name ? error.name : '';
  const message = error && error.message ? error.message : String(error || '');

  return (
    name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk [\d]+ failed/i.test(message) ||
    /CSS_CHUNK_LOAD_FAILED/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
};
